<template lang="pug">
v-container
  div.text-lg.font-medium.basic700--text {{ $t('story') }}
  div.text-sm.font-normal.basic600--text {{ $t('story_desc') }}

  page-editor.py-5.mt-4(v-if="showFroala" :parentForm.sync="form")

  div.d-flex.my-5
    v-spacer
    v-btn.round-lg.heading-6.pr-6.pl-5(color="basic700" outlined depressed height="48" @click="clickPreview")
      eva-icon.mb-n1.mr-2(name="eye-outline" fill="var(--v-basic700)")
      | {{ $t('preview') }}
    v-btn.round-lg.heading-6.px-8.ml-4(color="info500" dark depressed height="48" :loading="isLoading" @click="saveData") {{ $t('save') }}
  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PageEditor from '@/components/donation/PageEditor.vue'

export default {
  name: 'DetailsStory',
  components: { PageEditor },
  data () {
    return {
      isLoading: false,
      form: null,
      showFroala: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      campaign: 'donation/getCampaign'
    }),
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    }
  },
  mounted () {
    if (this.campaign) {
      this.setData(this.campaign)
    }
    this.$nextTick(() => {
      this.showFroala = true
    })
  },
  methods: {
    ...mapActions(['showMessage']),
    setData (campaign) {
      if (campaign.form.landing_field) {
        this.form = campaign.form.landing_field
      }
    },
    async saveData () {
      this.isLoading = true
      let data = {
        form: {
          landing_field: this.form
        }
      }
      await this.$axios.patch(`/donations/${this.company.slug}/campaigns/${this.campaign.form.slug}`, data)
        .then(resp => {
          this.$store.commit('donation/setCampaign', resp.data)
          this.setData(resp.data)
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async clickPreview () {
      await this.saveData()
      window.open(`https://${this.company.slug}.yezza.co/donation/${this.campaign.form.slug}`, '_blank')
    }
  }
}
</script>

<style scoped>

</style>